import Mock from '@/mocks/Mock'
import WeatherWarning2, { WeatherWarning2Attrs } from '@/models/WeatherWarning2'

export default class WeatherWarning2Mock extends Mock<WeatherWarning2Attrs> {
  constructor() {
    super('weather_warning2')
  }

  get(areaCode: string) {
    console.log(areaCode)

    return new WeatherWarning2(this.data)
  }
}
